<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar" />
      <div id="payment-page" class="qi-content">
        <header
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <h1>Seleção da Forma de Pagamento</h1>
          <b
            style="
              padding: 7.5px 15px;
              border-radius: 70px;
              background-color: #fff888;
            "
          >
            <div style="display: flex">
              <span
                style="font-size: 15px; margin-top: 2.35px; margin-right: 7.5px"
                class="material-icons"
              >
                dashboard
              </span>
              <span> SIMULAÇÃO </span>
            </div>
          </b>
        </header>
        <vs-row>
          <NewSale />
        </vs-row>
        <vs-row vs-justify="left">
          <SelectedCourseBoxSimulate></SelectedCourseBoxSimulate>
          <SelectedOfferBoxSimulate></SelectedOfferBoxSimulate>
        </vs-row>

        <h3>
          Selecione Parcelamento/Vencimento da Primeira Parcela
          <span v-if="level === 'S'">- Supervisão</span>
          <span v-if="level === 'C'">- Coordenação</span>
        </h3>
        <vs-row>
          <vs-col
            v-for="(installment, i) in installmentsOptions"
            :key="installment.IDPARCELAMENTO"
            vs-lg="4"
            vs-sm="6"
            vs-xs="12"
          >
            <div @click="selectInstallment(installment)">
              <vs-card
                class="choosable-card"
                :class="{
                  selected:
                    installment.IDPARCELAMENTO ===
                    installmentSelected.IDPARCELAMENTO,
                }"
              >
                <div class="no-flex" slot="header">
                  <h4 class="text-center">Opção {{ i + 1 }}</h4>
                </div>
                <div class="spacing-children">
                  <p>
                    Quant. máx. de parcelas:
                    {{ installment.NUMERODEPARCELAS }}
                  </p>

                  <div>
                    <label :for="'select-' + installment.IDPARCELAMENTO">
                      Data de Vencimento <br />
                      <p style="font-size: 0.75em">(1ª parcela)</p>
                    </label>
                    <vs-select
                      style="margin-top: -17.5px"
                      :id="'select-' + installment.IDPARCELAMENTO"
                      v-model="installment.dueDate"
                      v-if="installment.dueDateOptions.length"
                      :danger="checkDueDate(installment)"
                      danger-text="Selecione o vencimento da 1ª parcela"
                      v-on:change="updateSecondDueDateOptions()"
                    >
                      <vs-select-item
                        v-for="(date, index) in installment.dueDateOptions"
                        :key="index"
                        :value="date"
                        :text="date"
                      />
                    </vs-select>
                    <p v-else>Erro ao carregar opções de vencimento</p>
                  </div>
                </div>
                <div>
                  <label
                    :for="'num-of-installments-' + installment.IDPARCELAMENTO"
                  >
                    Número de Parcelas:
                  </label>
                  <vs-select
                    :id="'num-of-installments-' + installment.IDPARCELAMENTO"
                    v-model="installment.numberOfInstallments"
                    :disabled="!installmentSelected"
                    v-on:change="updateScholarShips(installment)"
                  >
                    <vs-select-item
                      v-for="(_, i) in numberOfInstallmentsPossible"
                      :key="i"
                      :value="i + 1"
                      :text="i + 1"
                    />
                  </vs-select>
                </div>

                <div
                  class="spacing-children"
                  v-if="
                    installment.ULTIMOVENCVALIDO2 != '0' &&
                    installment.numberOfInstallments > 1
                  "
                >
                  <div v-if="installment.showSecondDate">
                    <label :for="'select2-' + installment.IDPARCELAMENTO">
                      Data de Vencimento <br />
                      <p style="font-size: 0.75em">
                        (2ª parcela) <br />
                        * Referência ao início do curso
                      </p>
                    </label>
                    <vs-select
                      style="margin-top: -17.5px"
                      :id="'select2-' + installment.IDPARCELAMENTO"
                      v-model="installment.secondDueDate"
                      :danger="checkSecondDueDate(installment)"
                      danger-text="Selecione o vencimento da 2ª parcela"
                    >
                      <vs-select-item
                        v-for="(
                          date, index
                        ) in installment.secondDueDateOptions"
                        :key="index"
                        :value="date"
                        :text="date"
                      />
                    </vs-select>
                  </div>
                </div>
              </vs-card>
            </div>
          </vs-col>
        </vs-row>

        <div>
          <h3>Bolsas Disponíveis (opcional)</h3>
        </div>
        <p v-if="!scholarchipOptions">
          Sem bolsas disponíveis. Entre em contato com o Financeiro.
        </p>
        <vs-row style="margin-top: 10px" v-else>
          <vs-col
            v-for="scholarchip in scholarchipOptions"
            :key="scholarchip.IDBOLSA"
            vs-w="3"
            vs-xs="12"
          >
            <div @click="selectScholarship(scholarchip)">
              <vs-card
                class="choosable-card"
                :class="{ selected: scholarchip === scholarshipSelected }"
              >
                <div class="no-flex" slot="header">
                  <h4 class="text-center">{{ scholarchip.DESCRICAO }}</h4>
                  <div style="display: flex; justify-content: center">
                    <span
                      style="margin-top: 6.75px; font-size: 13.5px"
                      class="material-icons"
                    >
                      info
                    </span>
                    <p
                      class="text-center"
                      style="font-size: 1em; margin-top: 1.5px"
                    >
                      Máximo: <b>{{ parseFloat(scholarchip.PERCMAX) }}%</b>
                    </p>
                  </div>
                </div>
                <div
                  v-if="scholarchip.ALTERARVALOR == 'S'"
                  class="spacing-children"
                >
                  <vs-input
                    :id="'scholarship-' + scholarchip.IDBOLSA"
                    v-model="scholarchip.scholarshipPercent"
                    icon-after
                    icon="shopping_cart"
                    type="number"
                    :danger="scholarchip.isDiscountPercentOfflimits"
                    :success="scholarchip.percentAllowed"
                    :max="scholarchip.PERCMAX"
                    :min="0"
                    v-on:keyup="checkScholarshipValue"
                    v-on:blur="checkScholarshipValue"
                  />
                </div>
                <div v-else style="display: flex; justify-content: center">
                  <span
                    style="margin-top: 6.75px; font-size: 13.5px"
                    class="material-icons"
                  >
                    info
                  </span>
                  <p
                    class="text-center"
                    style="font-size: 1em; margin-top: 1.5px"
                  >
                    Percentual Fixo:
                    <b>{{ parseFloat(scholarchip.PERCMAX) }}%</b>
                  </p>
                </div>
                <p
                  class="text-center"
                  style="
                    margin-top: 15px;
                    margin-bottom: 5px;
                    font-size: 1em;
                    font-weight: bold;
                  "
                  v-if="scholarchip.QTDDISPONIVEL != '9999'"
                >
                  Quantidade Disponível: {{ scholarchip.QTDDISPONIVEL }}
                </p>
              </vs-card>
            </div>
          </vs-col>
        </vs-row>

        <div
          v-if="
            scholarshipSelected &&
            this.scholarshipSelected.scholarshipPercent != '' &&
            this.scholarshipSelected.scholarshipPercent != '0'
          "
        >
          <div>
            <h3>Bolsas Exceção (opcional)</h3>
          </div>
          <p v-if="!scholarchipOptionsException">
            Sem bolsas disponíveis. Entre em contato com o Financeiro.
          </p>
          <vs-row style="margin-top: 10px" v-else>
            <vs-col
              v-for="scholarchip in scholarchipOptionsException"
              :key="scholarchip.IDBOLSA"
              vs-w="3"
              vs-xs="12"
            >
              <div @click="selectScholarshipException(scholarchip)">
                <vs-card
                  class="choosable-card"
                  :class="{
                    selected: scholarchip === scholarshipSelectedException,
                  }"
                >
                  <div class="no-flex" slot="header">
                    <h4 class="text-center">{{ scholarchip.DESCRICAO }}</h4>
                    <div style="display: flex; justify-content: center">
                      <span
                        style="margin-top: 6.75px; font-size: 13.5px"
                        class="material-icons"
                      >
                        info
                      </span>
                      <p
                        class="text-center"
                        style="font-size: 1em; margin-top: 1.5px"
                      >
                        Percentual Fixo:
                        <b>{{ parseFloat(scholarchip.PMAX) }}%</b>
                      </p>
                    </div>
                    <p
                      class="text-center"
                      style="
                        margin-top: 15px;
                        margin-bottom: 5px;
                        font-size: 1em;
                        font-weight: bold;
                      "
                      v-if="scholarchip.QTDDISPONIVEL != '9999'"
                    >
                      Quantidade Disponível: {{ scholarchip.QTDDISPONIVEL }}
                    </p>
                  </div>
                </vs-card>
              </div>
            </vs-col>
          </vs-row>
        </div>
        <vs-row style="margin-top: -5px !important">
          <vs-col>
            <vs-button
              icon="highlight_off"
              :disabled="!scholarshipSelected && !scholarshipSelectedException"
              @click="clearScholarShip()"
              type="filled"
            >
              Remover Bolsa Selecionada
            </vs-button>
          </vs-col>
        </vs-row>
        <h3 style="margin-top: 10px">Selecione Forma de Pagamento</h3>
        <vs-row>
          <vs-col
            vs-lg="6"
            vs-sm="6"
            vs-xs="12"
            v-for="(payment, index) in paymentOptions"
            v-bind:key="index"
            :style="
              payment.DESCRICAO != 'Crédito Recorrente' &&
              payment.DESCRICAO != 'CRÉDITO RECORRENTE' &&
              payment.DESCRICAO != 'Recorrente' &&
              payment.DESCRICAO != 'RECORRENTE' &&
              ((installmentSelected.numberOfInstallments != 1 &&
                payment.AVISTA === 'S') ||
                (installmentSelected.numberOfInstallments == 1 &&
                  payment.AVISTA === 'N'))
                ? 'display: none;'
                : ''
            "
            :value="payment.IDFORMAPGTO"
          >
            <div @click="selectPayment(payment)">
              <vs-card
                class="choosable-card"
                :class="{ selected: payment === paymentSelected }"
              >
                <div slot="header">
                  <h3 class="text-center">
                    {{ payment.DESCRICAO.toUpperCase() }}
                  </h3>
                </div>
                <div class="spacing-children">
                  <p>
                    Valor Bruto da Parcela: R${{ getInstallmentValue(payment) }}
                  </p>
                  <p v-if="scholarshipSelected || scholarshipSelectedException">
                    Percentual de Bolsa Aplicado:
                    {{
                      !scholarshipSelected.scholarshipPercent &&
                      !scholarshipSelectedException
                        ? 0
                        : scholarshipSelected.scholarshipPercent &&
                          !scholarshipSelectedException
                        ? scholarshipSelected.scholarshipPercent
                        : parseFloat(scholarshipSelected.scholarshipPercent) +
                          parseFloat(scholarshipSelectedException.PMAX)
                    }}% (R${{ getScholarshipValue(payment) }})
                  </p>
                  <p>
                    Valor Líquido<b v-if="scholarshipSelected"> com Bolsa</b>:
                    R${{ getInstallmentLiquidValue(payment) }}
                  </p>
                  <p>
                    Desconto Adimplência:
                    {{ Number(payment.PERCDESC) }}% (R${{
                      getPaymentDiscount(payment)
                    }})
                  </p>
                  <p>
                    Valor Final:
                    <b>
                      {{ installmentSelected.numberOfInstallments }}
                      x R${{ getTotalValue(payment) }}
                    </b>
                  </p>
                </div>
              </vs-card>
            </div>
          </vs-col>
        </vs-row>

        <vs-alert
          title="Erro ao buscar as formas de pagamento do curso"
          class="margin"
          color="danger"
          v-if="error2"
        >
          {{ error2 }}
        </vs-alert>

        <vs-row v-show="error" vs-justify="center">
          <vs-col>
            <vs-alert
              color="danger"
              closable
              :active.sync="error"
              close-icon="close"
            >
              {{ error }}
            </vs-alert>
          </vs-col>
        </vs-row>

        <vs-row v-if="success" style="margin-top: 10px">
          <vs-alert
            color="success"
            closable
            :active.sync="success"
            close-icon="close"
          >
            <vs-col>
              Simulação Cadastrada com Sucesso! <br />
              <b>Código de Atendimento: {{ success.CODATENDIMENTO }}</b>
            </vs-col>
            <vs-col>
              <vs-button
                style="width: 100%"
                icon="send"
                color="#139B0E"
                @click="startSimulation()"
              >
                Ir para Matrícula
              </vs-button>
            </vs-col>
          </vs-alert>
        </vs-row>

        <vs-row v-else>
          <vs-col vs-w="4" vs-xs="12" v-if="level != 'S'">
            <vs-button
              icon="refresh"
              style="width: 100%"
              @click="updateInstallmentOptions('S')"
              type="filled"
              color="danger"
            >
              Carregar Opções Supervisor
            </vs-button>
          </vs-col>
          <vs-col vs-w="4" vs-xs="12" v-if="level == 'S'">
            <vs-button
              icon="highlight_off"
              style="width: 100%"
              @click="updateInstallmentOptions('V')"
              type="filled"
            >
              Remover Opções Supervisor
            </vs-button>
          </vs-col>
          <vs-col vs-w="4" vs-xs="12" v-if="level != 'C'">
            <vs-button
              icon="refresh"
              style="width: 100%"
              :disabled="!scholarshipCoordinator"
              @click="updateInstallmentOptions('C')"
              type="filled"
              color="danger"
            >
              Carregar Opções Coordenador
            </vs-button>
          </vs-col>
          <vs-col vs-w="4" vs-xs="12" v-if="level == 'C'">
            <vs-button
              icon="highlight_off"
              style="width: 100%"
              @click="updateInstallmentOptions('V')"
              type="filled"
            >
              Remover Opções Coordenador
            </vs-button>
          </vs-col>
          <vs-col vs-w="4" vs-xs="12">
            <vs-button
              icon="check_circle"
              style="width: 100%"
              :disabled="!paymentSelected.IDFORMAPGTO"
              @click="goFoward()"
              type="filled"
              color="#139B0E"
            >
              Cadastrar Simulação
            </vs-button>
          </vs-col>
        </vs-row>

        <vs-popup title="Informações Pessoais" :active.sync="sendInfo">
          <vs-row>
            <vs-card>
              <vs-col vs-w="6" vs-xs="12">
                <div>
                  <legend>Nome do Aluno</legend>
                  <vs-input name="nome" v-model="formName" />
                </div>
              </vs-col>
              <vs-col vs-w="6" vs-xs="12">
                <div>
                  <legend>Telefone do Aluno</legend>
                  <vs-input
                    name="telefone"
                    v-model="formPhone"
                    placeholder="(00) 00000-0000"
                    v-mask="'(##) #####-####'"
                  />
                </div>
              </vs-col>
              <vs-col>
                <div>
                  <vs-button
                    icon="check_circle"
                    :disabled="!formName || !formPhone || formPhone.length < 15"
                    style="width: 100%"
                    color="#139B0E"
                    @click="saveNewMailing()"
                  >
                    Cadastrar
                  </vs-button>
                </div>
              </vs-col>
            </vs-card>
          </vs-row>
        </vs-popup>
      </div>
    </div>
  </div>
</template>
<script>
import SelectedCourseBoxSimulate from "../components/SelectedCourseBoxSimulate.vue";
import SelectedOfferBoxSimulate from "../components/SelectedOfferBoxSimulate.vue";
import MailingService from "../services/mailing.js";
import {
  getLoginDataFromStorage,
  getStepsInformation,
  updateStepsInformation,
} from "../helpers/storage";
import FinancialService from "../services/financial";
import {
  formatDateToUSA,
  getDateOptions,
  getSecondDateOptions,
  formatDateToLocale,
} from "../helpers";
import moment from "moment";

export default {
  name: "Payment",
  components: {
    SelectedCourseBoxSimulate,
    SelectedOfferBoxSimulate,
  },
  data: () => ({
    scholarshipPercent: "",
    installmentSelected: null,
    installmentsOptions: [],
    numberOfInstallments: 1,
    paymentOptions: [],
    paymentSelected: {},
    isDiscountPercentOfflimits: false,
    percentAllowed: false,
    scholarchipOptions: null,
    scholarchipOptionsException: null,
    scholarshipSelected: null,
    scholarshipSelectedException: null,
    percentWatchTimeout: 0,
    totalCourseValue: 0,
    dueDate: "",
    error: null,
    error2: null,
    level: "V",
    offer: null,
    classData: null,
    infoTax: null,
    preRegistration: null,
    scholarshipCoordinator: false,
    formName: null,
    formPhone: null,
    sendInfo: false,
    subjectId: null,
    reEnrollment: false,
    userData: null,
    profiles: null,
    success: false,
  }),
  mounted() {
    this.$vs.loading();

    const { ...user } = getLoginDataFromStorage();
    this.userData = user.userData;
    this.profiles = user.profiles;

    const profileCoordinator = this.profiles.find(
      (element) => element == "SupervisorVenda"
    );

    if (profileCoordinator) {
      this.scholarshipCoordinator = true;
    } else {
      this.scholarshipCoordinator = false;
    }

    const { offerSimulate, courseSimulate } = getStepsInformation();
    this.offer = offerSimulate;
    let classificationId, qualificationId;
    classificationId = courseSimulate.IDCLASSIFICACAO;
    qualificationId = offerSimulate.IDHABILITACAOFILIAL;

    this.totalCourseValue = Number(courseSimulate.VALOR);

    this.updateInstallmentOptions(this.level);

    new FinancialService()
      .getPaymentOptions(classificationId, qualificationId, "P")
      .then(({ data }) => {
        this.paymentOptions = Array.isArray(data) ? data : [data];
      })
      .catch(({ response }) => {
        if (response && response.data) {
          this.error2 = response.data.error;
        }
      });
  },
  methods: {
    checkDueDate(installment) {
      if (installment == this.installmentSelected) {
        if (installment.dueDate == "") return true;
      }
    },

    checkSecondDueDate(installment) {
      if (installment == this.installmentSelected) {
        if (installment.secondDueDate == "") return true;
      }
    },

    dataMaxima(tax) {
      const partesData = tax.split("/");
      const data = new Date(partesData[2], partesData[1] - 1, partesData[0]);

      if (data.getDate() <= 15) {
        const primeiroDiaDoProximoMes = new Date(
          data.getFullYear(),
          data.getMonth() + 1,
          1
        );
        const ultimoDiaDoMes = new Date(primeiroDiaDoProximoMes - 1);
        return (
          ultimoDiaDoMes.getDate() +
          "/" +
          (ultimoDiaDoMes.getMonth() + 1 < 10
            ? "0" + (ultimoDiaDoMes.getMonth() + 1)
            : ultimoDiaDoMes.getMonth() + 1) +
          "/" +
          ultimoDiaDoMes.getFullYear()
        );
      } else {
        const proximoMes = new Date(data.getFullYear(), data.getMonth() + 1);

        let count = 0;
        let dia = 1;
        let dataAtual = new Date(proximoMes);

        while (count < 5) {
          dataAtual.setDate(dia);
          const diaSemana = dataAtual.getDay();
          if (diaSemana !== 0) {
            count++;
          }
          dia++;
        }

        return dataAtual;
      }
    },

    updateInstallmentOptions(level) {
      this.level = level;
      this.installmentsOptions = [];
      this.installmentSelected = null;
      this.scholarchipOptions = [];
      this.scholarchipOptionsException = [];
      this.scholarshipSelected = null;
      this.scholarshipSelectedException = null;
      const { offerSimulate, courseSimulate, taxSimulate } =
        getStepsInformation();
      let classificationId, qualificationId, subjectId, taxDueDate;
      classificationId = courseSimulate.IDCLASSIFICACAO;
      qualificationId = offerSimulate.IDHABILITACAOFILIAL;
      subjectId = 0;
      taxDueDate = formatDateToUSA(taxSimulate.dueDate);

      new FinancialService()
        .getInstallment(
          classificationId,
          qualificationId,
          this.level,
          formatDateToUSA(new Date()),
          subjectId,
          taxDueDate
        )
        .then(({ data }) => {
          const installmentsOptionsAux = Array.isArray(data) ? data : [data];
          this.installmentsOptions = installmentsOptionsAux.map(
            (installment) => ({
              ...installment,
              dueDateOptions: getDateOptions(
                moment(formatDateToLocale(taxDueDate), "DD/MM/YYYY").add(
                  1,
                  "days"
                ),
                taxSimulate && taxSimulate.VALORTAXA == "78.99"
                  ? moment(this.dataMaxima(taxSimulate.dueDate), "DD/MM/YYYY")
                  : moment(installment.ULTIMOVENCVALIDO, "DD/MM/YYYY")
              ),
              dueDate: "",
              secondDueDateOptions: [],
              secondDueDate: "",
              numberOfInstallments: 1,
              showSecondDate: moment(
                installment.ULTIMOVENCVALIDO2,
                "DD/MM/YYYY"
              ).isAfter(moment(installment.ULTIMOVENCVALIDO, "DD/MM/YYYY")),
            })
          );
          this.installmentSelected = this.installmentsOptions[0];

          this.getScholarShip();
          this.$vs.loading.close();
        })
        .catch(({ response }) => {
          if (response && response.data) {
            this.error = response.data.error;
          }
          this.$vs.loading.close();
        });
    },

    selectPayment(paymentMethod) {
      this.paymentSelected = paymentMethod;
      const { taxSimulate } = getStepsInformation();
      let today = new Date();
      today.setDate(today.getDate() + 5);
      today = formatDateToLocale(today);

      if (this.paymentSelected.AVISTA === "S") {
        this.installmentSelected.numberOfInstallments = 1;
        this.installmentSelected.dueDate = taxSimulate.dueDate;
      }
    },

    selectInstallment(installment) {
      this.installmentSelected = installment;
      this.dueDateSecondInstallment = "";
      this.updateScholarShips();
      this.updateSecondDueDateOptions();
    },

    selectScholarship(scholarship) {
      this.scholarshipSelectedException = null;
      this.scholarshipSelected = scholarship;
      if (this.scholarshipSelected.ALTERARVALOR == "N") {
        this.scholarshipSelected.scholarshipPercent =
          this.scholarshipSelected.PERCMAX;
        this.scholarshipSelected.percentAllowed = true;
      } else if (this.scholarshipSelected.scholarshipPercent) {
        if (
          parseFloat(this.scholarshipSelected.scholarshipPercent) >
          parseFloat(this.scholarshipSelected.PERCMAX)
        ) {
          this.scholarshipSelected.scholarshipPercent = parseFloat(
            this.scholarshipSelected.PERCMAX
          );
          this.scholarshipSelected.isDiscountPercentOfflimits = true;
        }
      }
    },

    selectScholarshipException(scholarship) {
      this.scholarshipSelectedException = scholarship;
      this.scholarshipSelectedException.scholarshipPercent =
        this.scholarshipSelectedException.PMAX;
      this.scholarshipSelectedException.percentAllowed = true;
    },

    updateSecondDueDateOptions() {
      if (!this.installmentSelected.showSecondDate) {
        this.installmentSelected.secondDueDate = formatDateToLocale(
          moment(this.installmentSelected.dueDate, "DD/MM/YYYY").add(1, "month")
        );
      } else if (
        this.installmentSelected.ULTIMOVENCVALIDO2 != "0" &&
        this.installmentSelected.numberOfInstallments > 1
      ) {
        this.installmentSelected.secondDueDateOptions = getSecondDateOptions(
          moment(this.installmentSelected.dueDate, "DD/MM/YYYY").add(
            1,
            "month"
          ),
          moment(this.installmentSelected.ULTIMOVENCVALIDO2, "DD/MM/YYYY")
        );
        this.installmentSelected.secondDueDate =
          this.installmentSelected.secondDueDateOptions[0];
      } else {
        if (this.installmentSelected.dueDate != "") {
          this.installmentSelected.secondDueDate = formatDateToLocale(
            moment(this.installmentSelected.dueDate, "DD/MM/YYYY").add(
              1,
              "month"
            )
          );
        }
      }
    },

    getScholarShip() {
      this.scholarchipOptions = null;
      this.scholarchipOptionsException = null;
      this.scholarshipSelected = null;
      this.scholarshipSelectedException = null;
      const { offerSimulate, courseSimulate } = getStepsInformation();
      let classificationId, qualificationId, subjectId;
      classificationId = courseSimulate.IDCLASSIFICACAO;
      qualificationId = offerSimulate.IDHABILITACAOFILIAL;
      subjectId = 0;
      new FinancialService()
        .getScholarships(
          classificationId,
          qualificationId,
          this.level,
          formatDateToUSA(new Date()),
          subjectId,
          this.installmentSelected.numberOfInstallments
        )
        .then(({ data }) => {
          const scholarchipOptionsAux = Array.isArray(data) ? data : [data];

          const filteredScholarships = scholarchipOptionsAux.filter(
            (scholarship) => scholarship.TIPOBOLSA != "P"
          );

          if (filteredScholarships.length > 0) {
            this.scholarchipOptions = filteredScholarships.map(
              (scholarchip) => ({
                ...scholarchip,
                scholarshipPercent: parseFloat(scholarchip.PERCMAX),
                isDiscountPercentOfflimits: false,
                percentAllowed: true,
              })
            );
          }
        });

      new FinancialService()
        .getScholarshipsException(
          classificationId,
          qualificationId,
          this.level,
          formatDateToUSA(new Date()),
          subjectId,
          this.installmentSelected.numberOfInstallments
        )
        .then(({ data }) => {
          const scholarchipOptionsAux = Array.isArray(data) ? data : [data];
          if (scholarchipOptionsAux[0] != "") {
            this.scholarchipOptionsException = scholarchipOptionsAux.map(
              (scholarchip) => ({
                ...scholarchip,
                scholarshipPercent: 0,
                isDiscountPercentOfflimits: false,
                percentAllowed: false,
              })
            );
          }
        });
    },

    updateScholarShips(installment) {
      this.getScholarShip();
      this.updateSecondDueDateOptions(installment);
    },

    checkScholarshipValue() {
      this.scholarshipSelected.isDiscountPercentOfflimits = false;
      this.scholarshipSelected.percentAllowed = false;
      if (
        this.scholarshipSelected.scholarshipPercent !== 0 ||
        this.scholarshipSelected.scholarshipPercent !== ""
      ) {
        if (parseFloat(this.scholarshipSelected.scholarshipPercent) < 0) {
          this.scholarshipSelected.scholarshipPercent = "";
        } else if (
          parseFloat(this.scholarshipSelected.scholarshipPercent) >
          parseFloat(this.scholarshipSelected.PERCMAX)
        ) {
          this.scholarshipSelected.isDiscountPercentOfflimits = true;
          this.scholarshipSelected.scholarshipPercent = parseFloat(
            this.scholarshipSelected.PERCMAX
          );
        } else {
          this.scholarshipSelected.percentAllowed = true;
        }
      } else {
        this.scholarshipSelected.scholarshipPercent = 0;
      }
    },

    clearScholarShip() {
      this.scholarshipSelected = null;
      this.scholarshipSelectedException = null;
    },

    goFoward() {
      this.formName = null;
      this.formPhone = null;
      this.sendInfo = true;

      updateStepsInformation({
        paymentAttendance:
          "Selecionou Financeiro: Matrícula em " +
          this.installmentSelected.numberOfInstallments +
          "x, com 1º vencimento em " +
          this.installmentSelected.dueDate +
          (this.scholarshipSelected &&
          this.scholarshipSelected.scholarshipPercent &&
          this.scholarshipSelected.scholarshipPercent != null &&
          this.scholarshipSelected.scholarshipPercent != "0"
            ? " e " +
              this.scholarshipSelected.scholarshipPercent +
              "% de bolsa,"
            : " - SEM BOLSA SELECIONADA -") +
          " no " +
          this.paymentSelected.DESCRICAO,
      });
    },

    saveNewMailing() {
      this.sendInfo = false;
      this.success = false;

      const {
        courseAttendance,
        offerAttendance,
        taxAttendance,
        paymentAttendance,
      } = getStepsInformation();

      const payload = {
        NOME: this.formName,
        TELEFONE: this.formPhone,
        CODTIPOATENDIMENTO: "213",
        TEXTOSOLICITACAO:
          "Nome: " +
          this.formName +
          "\n" +
          "Telefone: " +
          this.formPhone +
          "\n\n" +
          courseAttendance +
          "\n" +
          offerAttendance +
          "\n" +
          taxAttendance +
          "\n" +
          paymentAttendance,
        CODLOCAL: this.userData.CODLOCAL,
        CODATENDENTE: this.userData.CODATENDENTE,
      };

      this.$vs.loading();
      new MailingService()
        .createLeadSimulated(payload)
        .then((res) => {
          this.success = res.data;
        })
        .catch((error) => {
          console.error("Error: " + error);
          this.error =
            "Falha ao tentar cadastrar simulação. " +
            (error?.response?.data?.error || "");
        })
        .finally(() => {
          setTimeout(() => {
            this.$vs.loading.close();
          }, 200);
        });
    },

    startSimulation() {
      updateStepsInformation({
        codAtendimento: this.success.CODATENDIMENTO,
        codColigada: this.success.CODCOLIGADA,
        codLocal: this.success.CODLOCAL,
      });
      this.$router.push("/courses");
    },

    getInstallmentValue(payment) {
      const { installmentSelected, totalCourseValue } = this;
      const installments =
        payment.AVISTA === "S" ? 1 : installmentSelected.numberOfInstallments;
      return installmentSelected
        ? (totalCourseValue / installments).toFixed(2)
        : 0;
    },

    getInstallmentLiquidValue(payment) {
      const installmentValue = this.getInstallmentValue(payment);
      if (this.installmentSelected && this.scholarshipSelected) {
        if (
          this.scholarshipSelected.scholarshipPercent != "" &&
          !this.scholarshipSelectedException
        ) {
          return (
            (installmentValue *
              (100 - parseFloat(this.scholarshipSelected.scholarshipPercent))) /
            100
          ).toFixed(2);
        } else if (
          this.scholarshipSelected.scholarshipPercent != "" &&
          this.scholarshipSelectedException
        ) {
          return (
            (installmentValue *
              (100 -
                parseFloat(this.scholarshipSelected.scholarshipPercent) -
                parseFloat(this.scholarshipSelectedException.PMAX))) /
            100
          ).toFixed(2);
        }
      }
      return installmentValue;
    },

    getScholarshipValue(payment) {
      if (this.scholarshipSelected && !this.scholarshipSelectedException) {
        const installmentValue = this.getInstallmentValue(payment);
        return (
          installmentValue *
          (this.scholarshipSelected.scholarshipPercent / 100)
        ).toFixed(2);
      } else if (
        this.scholarshipSelected &&
        this.scholarshipSelectedException
      ) {
        const installmentValue = this.getInstallmentValue(payment);
        return (
          installmentValue *
          ((parseFloat(this.scholarshipSelected.scholarshipPercent) +
            parseFloat(this.scholarshipSelectedException.PMAX)) /
            100)
        ).toFixed(2);
      } else {
        return 0;
      }
    },
    getPaymentDiscount(payment) {
      const installmentValue = this.getInstallmentLiquidValue(payment);
      return installmentValue && +payment.PERCDESC
        ? (installmentValue * (+payment.PERCDESC / 100)).toFixed(2)
        : 0;
    },
    getTotalValue(payment) {
      const { getScholarshipValue, getPaymentDiscount, getInstallmentValue } =
        this;
      const installmentValue = getInstallmentValue(payment);
      return (
        installmentValue -
        getScholarshipValue(payment) -
        getPaymentDiscount(payment)
      ).toFixed(2);
    },
  },

  computed: {
    numberOfInstallmentsPossible() {
      if (!this.installmentSelected) return [0];
      return Array.from(
        Array(+this.installmentSelected.NUMERODEPARCELAS).keys()
      );
    },
  },
};
</script>

<style>
#payment-page .no-flex div.vs-col {
  flex: 0 !important;
}
#payment-page .text-center {
  text-align: center;
}
#payment-page .choosable-card {
  cursor: pointer;
}

#payment-page .choosable-card:hover {
  cursor: pointer;
  box-shadow: 0 0 5px 3px rgba(var(--vs-primary), 0.7);
}

#payment-page .choosable-card.selected {
  box-shadow: 0 0 0 2.75px rgb(var(--vs-primary)) !important;
  cursor: default;
}

#payment-page .choosable-card.disabled,
#payment-page .choosable-card.disabled:hover {
  cursor: default;
  color: #888;
  box-shadow: none;
}

#payment-page .select-due-date {
  display: flex;
  justify-content: space-between;
}

#payment-page .select-due-date select {
  display: flex;
  justify-content: space-between;
}

#payment-page .spacing-children > p,
#payment-page .spacing-children > div {
  margin: 12px 0;
}

#payment-page .no-material-font i {
  font-family: Verdana, sans-serif;
}
</style>
